import { render, staticRenderFns } from "./RepairExtension.vue?vue&type=template&id=24dfa0f4&scoped=true"
import script from "./RepairExtension.vue?vue&type=script&lang=js"
export * from "./RepairExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfa0f4",
  null
  
)

export default component.exports